module.exports = __webpack_public_path__ + "media/images/guideline/B03-3a7bd47cc01a519f3c2f798aee8a6aa0.jpg";